import {
  canonicalErrorMessage,
  IdentityErrorCode,
} from "./types";

export interface IdentityErrorProps {
  code?: IdentityErrorCode | null;
  message?: string;
}

export function IdentityError({ code, message }: IdentityErrorProps) {
  const displayed =
    message && message.trim()
      ? message
      : canonicalErrorMessage(code ?? null, "SpeedyCore Identity: Authentication error");
  return (
    <p
      className="sc-identity-error"
      role="alert"
      aria-live="polite"
      data-code={code ?? ""}
    >
      {displayed}
    </p>
  );
}
